// import { retrieveModel } from "../general/retrieveModel";

export const retrieveModelForTeamMember = async ( functionParameters = {} ) => {
    
      // const {  token, copyApiEndPoint, isCopying, title, submitText, instructionTitle} = functionParameters;
      let {smartboxStorageName, modelPath, url } = functionParameters;

      if(window["confirmCreateTeamMemberSmartbox"] ) window["confirmCreateTeamMemberSmartbox"].close();

      smartboxStorageName = smartboxStorageName || "retrieveModelForTeamMemberSmartbox";

      const retrieveModel = (await import(/* webpackPrefetch: true */ "../general/retrieveModel")).retrieveModel;

      functionParameters["submissionFuncPath"] = "apps/teamMembers/updatePartsOfTeamMember";
      functionParameters["sideMenuToUse"] = "teamMembers";
      functionParameters["smartboxStorageName"] = smartboxStorageName;
      functionParameters["modelPath"] = "loggedInUser/treatments/newTeamMemberModel";
      functionParameters["doNotSaveFormData"] = true;
      
      

      return await retrieveModel(functionParameters);
    

};